export default "__VITE_ASSET__DpIOueIS__"